/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeploymentUsageSummaryDto
 */
export interface DeploymentUsageSummaryDto {
    /**
     * The date for which the summary has been create.
     * @type {string}
     * @memberof DeploymentUsageSummaryDto
     */
    date: string;
    /**
     * The total cores at the specified dat.
     * @type {number}
     * @memberof DeploymentUsageSummaryDto
     */
    totalCores: number;
    /**
     * The total memory at the specified date (in GB.
     * @type {number}
     * @memberof DeploymentUsageSummaryDto
     */
    totalMemoryGB: number;
    /**
     * The total volume at the specified date (in GB.
     * @type {number}
     * @memberof DeploymentUsageSummaryDto
     */
    totalVolumeGB: number;
    /**
     * The total storage at the specified date (in GB.
     * @type {number}
     * @memberof DeploymentUsageSummaryDto
     */
    totalStorageGB: number;
}

/**
 * Check if a given object implements the DeploymentUsageSummaryDto interface.
 */
export function instanceOfDeploymentUsageSummaryDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "totalCores" in value;
    isInstance = isInstance && "totalMemoryGB" in value;
    isInstance = isInstance && "totalVolumeGB" in value;
    isInstance = isInstance && "totalStorageGB" in value;

    return isInstance;
}

export function DeploymentUsageSummaryDtoFromJSON(json: any): DeploymentUsageSummaryDto {
    return DeploymentUsageSummaryDtoFromJSONTyped(json, false);
}

export function DeploymentUsageSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentUsageSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'totalCores': json['totalCores'],
        'totalMemoryGB': json['totalMemoryGB'],
        'totalVolumeGB': json['totalVolumeGB'],
        'totalStorageGB': json['totalStorageGB'],
    };
}

export function DeploymentUsageSummaryDtoToJSON(value?: DeploymentUsageSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'totalCores': value.totalCores,
        'totalMemoryGB': value.totalMemoryGB,
        'totalVolumeGB': value.totalVolumeGB,
        'totalStorageGB': value.totalStorageGB,
    };
}

